import DatacorLogoSpinner from '../../../../../../components/datacorLogoSpinner/DatacorLogoSpinner';
import React from 'react';
import FormPartial from '../../../../../../components/form/formContainer/FormPartial';
import SubSection4_1Form from './subSections/subSection4_1/SubSection4_1Form';
import SubSection4_2Form from './subSections/subSection4_2/SubSection4_2Form';
import SubSection4_3Form from './subSections/subSection4_3/SubSection4_3Form';
import { SdsBlobSectionFormProps } from '../shared/blobs/hooks/SdsBlobSectionFormProps';
import { SdsHeader } from '../../../../../../types/formulation';
import TranslatableText from '../../../../../../components/i18n/TranslatableText';
import { SDSFormDefs } from '../../../../../../constants/i18n/translations/termDefinitions/formulation';

const SdsFirstAidMeasuresForm = (props: SdsBlobSectionFormProps<SdsHeader>) => {
    const { isParentLoading } = props.parentData;
    return (
        <>
            {isParentLoading ? (
                <DatacorLogoSpinner />
            ) : (
                <>
                    <FormPartial
                        link={props?.link}
                        title={
                            (
                                <TranslatableText
                                    termSet={props.termSet}
                                    termKey={SDSFormDefs.First_Aid_Measure}
                                />
                            ) as unknown as string
                        }>
                        <SubSection4_1Form {...props} termSet={props.termSet} />
                        <SubSection4_2Form {...props} termSet={props.termSet} />
                        <SubSection4_3Form {...props} termSet={props.termSet} />
                    </FormPartial>
                </>
            )}
        </>
    );
};

export default SdsFirstAidMeasuresForm;
